/* Progressive enhancement only. Core links and tips work without JS.
   Shopify Customer Events inherit the store's existing pixel and consent setup. */
(() => {
  'use strict';
  const init = (root) => {
    if (root.dataset.quickHelpReady === 'true') return;
    root.dataset.quickHelpReady = 'true';
    const button = root.querySelector('[data-copy-model]');
    const status = root.querySelector('[data-copy-status]');
    const model = root.dataset.productModel || '';
    const publish = (name, data) => {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    };
    publish('plugable:quick_help_viewed', { sku: model, path: window.location.pathname });
    const photo = root.querySelector('.qh-product__image');
    const photoFallback = root.querySelector('[data-image-fallback]');
    if (photo && photoFallback) {
      const showFallback = () => { photo.hidden = true; photoFallback.hidden = false; };
      photo.addEventListener('error', showFallback, { once: true });
      if (photo.complete && photo.naturalWidth === 0) showFallback();
    }
    if (button && model) {
      button.hidden = false;
      button.addEventListener('click', async () => {
        const label = button.querySelector('[data-copy-label]');
        try {
          if (!navigator.clipboard || !window.isSecureContext) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(model);
          if (label) label.textContent = 'Copied';
          if (status) status.textContent = `${model} copied. Paste it into your support message or AI chat.`;
          window.setTimeout(() => { if (label) label.textContent = 'Copy'; }, 2500);
        } catch (_) {
          const text = root.querySelector('[data-model-text]');
          const selection = window.getSelection();
          if (text && selection) {
            const range = document.createRange();
            range.selectNodeContents(text);
            selection.removeAllRanges();
            selection.addRange(range);
          }
          if (label) label.textContent = 'Select';
          if (status) status.textContent = `Copy the selected model number: ${model}.`;
        }
      });
    }
    /* Publish one custom event through Shopify's existing pixels. GA4 requires
       a mapping/subscription in the store's current tracking configuration. */
    root.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const link = target && target.closest('a[data-help-action]');
      if (!link || !root.contains(link)) return;
      publish('plugable:quick_help_action', {
        sku: model, action: link.dataset.helpAction, destination: link.href
      });
      document.dispatchEvent(new CustomEvent('plugable:quick-help-action', {
        detail: { model, action: link.dataset.helpAction, destination: link.href }
      }));
    });
  };
  const scan = () => document.querySelectorAll('[data-quick-help]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
